<template>

  <div class="record" id="RECORD-SWF">
    <div class="tips">网页版无法使用此功能,请下载专业版!</div>
    <div class="btn">
      <div class="mac">
        <span class="icon-mac"></span>
        <span>Mac版</span>
      </div>
      <div class="windows">
        <span class="icon-windows">
        <span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span>
        </span>
        <span class="plat">Windows版</span>
      </div>
    </div>
  </div>  
</template>

<script>

  // 通讯协议
  import Protocol from '@/common/scripts/protocol.js'

  export default {
    name: 'RECORD',
    data () {
      return {

        init: '',

        // -------------------------------------------------- [ FLASH ] --------------------------------------------------

      }
    },
    mounted () {

      let platform = this.$route.query.platform
      let _this = this

      // 模块初始化
      Protocol.onSocketInit(platform, RECORD_NAME, RECORD)
      // 模块与服务器建立链接
      Protocol.onSocketConnect(platform,RECORD_NAME)
      // 模块与服务器建立链接
      Protocol.onSocketRegister(platform, RECORD_NAME, RECORD)

      // 接收消息
      Protocol.receiver(platform, RECORD_NAME)

      window[RECORD_NAME].message = function (senderId, packageId, sessionId, messageId, protoBytes) {

        if (sessionId == 6 && messageId == 5) {

          let token = Protocol.deserializeBinary('proto.com.proto.s.MToken', protoBytes).array.toString()

          _this.init = 'complete'

          console.log('[' + RECORD_NAME + '][COMPLETE]')
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .record
    background: #505050//#e8e8e8
    position: absolute
    top: 30px
    right: 0
    bottom: 0
    left: 0
    .tips
      width 180px
      margin 0 auto
      margin-top 100px
      font-size 12px
      text-align center
      color #e2e2e2//#565656
      line-height 150%
    .btn
      width 180px
      margin 0 auto
      margin-top 35px
      div
        height 40px
        line-height 40px
        border-radius 4px
        text-align center
        margin-top 20px
        cursor pointer
      .mac
        background #000
        color #fff
        font-size 16px
      .windows
        background #fff
        font-size 16px
        .plat
          color #000     
</style>


// WEBPACK FOOTER //
// Record.vue?6c38e84c